import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';


const __default__ = { name: 'ProspectsByStatus' }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

// === Dark mode (sólo para tooltip/labels) ===
const isDarkMode = ref(window.matchMedia('(prefers-color-scheme: dark)').matches);
window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', e => isDarkMode.value = e.matches);

// === Datos base ===
const categories = computed(() => Object.keys(props.data || {}));

const series = computed(() => [
  {
    name: 'Total',
    data: Object.values(props.data || {}).map((item: any) => Number(item.total_quotations ?? 0)),
  }
]);

// === Paletas dinámicas por hostname ===
const hostname = window.location.hostname;

const dominiomediosPalette = [
  '#be103b', '#88102e', '#6e0f26', '#a1293a',
  '#944249', '#b5696d', '#be103b'
];

// Escala azul basada en #2563eb (Tailwindish)
const blueScaleBase = [
  '#1e3a8a', // blue-900
  '#1d4ed8', // blue-700
  '#2563eb', // blue-600 (tu color pedido)
  '#3b82f6', // blue-500
  '#60a5fa', // blue-400
  '#93c5fd', // blue-300
  '#bfdbfe'  // blue-200
];

const computedColors = computed(() => {
  const n = categories.value.length || 7;

  // Host específico
  if (hostname === 'crm.dominiomedios.com') {
    // recorta o cicla si hay más categorías que colores
    if (n <= dominiomediosPalette.length) return dominiomediosPalette.slice(0, n);
    return Array.from({ length: n }, (_, i) => dominiomediosPalette[i % dominiomediosPalette.length]);
  }

  // Default: escala azul
  if (n <= blueScaleBase.length) return blueScaleBase.slice(0, n);
  return Array.from({ length: n }, (_, i) => blueScaleBase[i % blueScaleBase.length]);
});

// === Opciones del gráfico ===
const chartOptions = computed(() => ({
  chart: { type: 'bar' },
  plotOptions: {
    bar: {
      horizontal: true,
      dataLabels: { position: 'top' }
    }
  },
  dataLabels: {
    offsetX: -15,
    offsetY: 1,
    enabled: true,
    formatter: (val: number) => val,
    style: { colors: ['#fff'] }
  },
  xaxis: {
    categories: categories.value,
    labels: { show: false }
  },
  yaxis: {
    labels: { style: { colors: isDarkMode.value ? '#fff' : '#333' } }
  },
  grid: { show: false },
  colors: computedColors.value, // ← aquí usamos la paleta dinámica
  tooltip: {
    theme: isDarkMode.value ? 'dark' : 'light',
    y: {
      formatter: (val: number, { dataPointIndex }) => {
        const etapas = Object.keys(props.data || {});
        const key = etapas[dataPointIndex];
        const sumTotal = (props.data?.[key]?.sum_total ?? 0);
        return parseFloat(sumTotal).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
      }
    }
  }
}));

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "py-4 px-6"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Cotizaciones por status de oportunidad")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_apexchart, {
        type: "bar",
        height: 300,
        options: chartOptions.value,
        series: series.value
      }, null, 8, ["options", "series"])
    ]),
    _: 1
  }))
}
}

})